/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
import React from 'react';
import Callout from '../../Callout';
import Markdown from '../../Markdown';
import content from './gettingStarted.md';
import GuidelinePage from '../../GuidelinePage';

export default function GettingStarted() {
  return (
    <GuidelinePage>
      <Markdown scope={{ Callout }}>{content}</Markdown>
    </GuidelinePage>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/pages/GettingStarted/index.js